import { createContext, useContext } from 'react';
import type { SessionProviderQuery$data } from '@/__generated__/SessionProviderQuery.graphql';

// Contexto da sessão separado do provider (que tem as queries `graphql`), para telas, stories e
// testes usarem `useSession` sem precisar do Relay.

export type Viewer = NonNullable<SessionProviderQuery$data['viewer']>;

/**
 * - `loading`: consultando o server.
 * - `demo`: auth indisponível (server sem banco, fora do ar ou sem o schema novo). As telas seguem
 *   abertas com dados mock, como antes do login existir.
 * - `ready`: auth ligada; `viewer` nulo = sem sessão.
 */
export type SessionState =
  | { status: 'loading' }
  | { status: 'demo' }
  | { status: 'ready'; viewer: Viewer | null; signupMode: 'OPEN' | 'INVITE' | '%future added value' };

export type AuthResult = { error: string | null };

export type Session = SessionState & {
  refresh: () => Promise<void>;
  signIn: (email: string, password: string) => Promise<AuthResult>;
  signUp: (name: string, email: string, password: string) => Promise<AuthResult>;
  signOut: () => Promise<void>;
};

export const AUTH_UNAVAILABLE = 'Login ainda indisponível: o servidor ainda não tem banco de dados configurado.';
export const NETWORK_ERROR = 'Não foi possível falar com o servidor. Tente de novo.';

const unavailable = async (): Promise<AuthResult> => ({ error: AUTH_UNAVAILABLE });

/** Sem provider (testes, Storybook): modo demonstração. */
const DEMO: Session = { status: 'demo', refresh: async () => {}, signIn: unavailable, signUp: unavailable, signOut: async () => {} };

/** Exportado para testes e stories. */
export const SessionContext = createContext<Session>(DEMO);

export const useSession = () => useContext(SessionContext);

